"use client";
import { type FormFieldProps } from "@/components/site-builder/modules/CustomFormModule/components/FormFieldMapper/types";
import TextField from "@/components/site-builder/TextField";
import { createBasicTextFieldObject } from "@/utils/site-builder/createBasicTextFieldObject";

export default function CustomFormText(props: FormFieldProps) {
  const {
    field: { header, text },
  } = props;

  return (
    <div>
      {header && (
        <TextField
          type="sub-title"
          field={createBasicTextFieldObject(header)}
        />
      )}
      {text && (
        <TextField
          type="text-regular"
          field={createBasicTextFieldObject(text)}
        />
      )}
    </div>
  );
}
